import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";
import { FaRocket, FaArrowRight } from "react-icons/fa";

const CallToAction = () => {
    const { isAuthenticated } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleButtonClick = () => {
        if (isAuthenticated) {
            navigate("/products");
        } else {
            navigate("/auth/signup");
        }
    };

    return (
        <section className="py-20 bg-gradient-to-r from-blue-600 to-blue-700">
            <div className="max-w-6xl mx-auto px-8">
                <div className="text-center">
                    <FaRocket className="text-5xl text-white mx-auto mb-6 animate-bounce" />
                    <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
                        {isAuthenticated ? "Ready to Discover Risks?" : "Start Your Risk Assessment Journey"}
                    </h2>
                    <p className="text-xl text-blue-100 max-w-2xl mx-auto mb-8">
                        Join thousands of businesses that trust RiskDiscover for comprehensive risk intelligence. 
                        Get started in minutes with our AI-powered platform.
                    </p>
                    
                    <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                        <button
                            onClick={handleButtonClick}
                            className="group bg-white text-blue-600 px-8 py-4 rounded-lg font-semibold text-lg hover:bg-blue-50 transition-all transform hover:scale-105 flex items-center"
                        >
                            {isAuthenticated ? "Explore Products" : "Start Free Trial"}
                            <FaArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
                        </button>
                        
                        {!isAuthenticated && (
                            <button
                                onClick={() => navigate("/auth/signin")}
                                className="text-white border-2 border-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-white hover:text-blue-600 transition-colors"
                            >
                                Sign In
                            </button>
                        )}
                    </div>
                    
                    <div className="mt-12 grid grid-cols-3 gap-8 text-white">
                        <div>
                            <div className="text-3xl font-bold">10K+</div>
                            <div className="text-blue-100">Active Users</div>
                        </div>
                        <div>
                            <div className="text-3xl font-bold">50K+</div>
                            <div className="text-blue-100">Risk Assessments</div>
                        </div>
                        <div>
                            <div className="text-3xl font-bold">99.9%</div>
                            <div className="text-blue-100">Accuracy Rate</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CallToAction;